import React from 'react'
import styled from 'styled-components'

import { Button } from 'ui/chandra'
import { useSurveyContext } from '../_store'
import { callAll } from 'utils'
import { survey_finished_event } from 'gtm/pushEvents'
import { useCookies } from 'react-cookie'

const SubmitButton = () => {
  const { state, actions } = useSurveyContext()
  const step = state.pages[`step_${state.step}`]
  const [, , removeCookie] = useCookies(['user_starts_survey'])

  const unanswered = () =>
    !step.page.layoutContent.components.find((component) => {
      const value = step.formData[component.slug]
      return value && (typeof value === 'boolean' || value.length > 0)
    })

  const skip = step.skippable && unanswered()

  const TransitionButton = styled(Button)({
    transition: 'all 250ms ease-in-out',
    width: '100%',
    letterSpacing: '1.28px'
  })

  const buttonText = () => {
    if (step.page.last) {
      return 'Submit'
    } else {
      return `NEXT`
    }
  }

  const buttonTextSkip = () => {
    if (skip) {
      return 'Skip'
    }
  }

  const onSubmitHandler = () => {
    if (step.page.last) {
      removeCookie('user_starts_survey', { path: '/' })
      return callAll(
        survey_finished_event(),
        actions.submit({ step: state.step })
      )
    } else {
      return actions.submit({ step: state.step })
    }
  }

  return (
    <div>
      <TransitionButton
        id='nxt_question_idk_submit_btn'
        onClick={onSubmitHandler}
        variant={'solid'}
        disabled={!step.valid}
        processing={state.loading}
      >
        {buttonText()}
      </TransitionButton>
      {skip && (
        <TransitionButton
          id='skip_next_question_submit_btn'
          onClick={onSubmitHandler}
          variant={'dim'}
          disabled={!step.valid}
          processing={state.loading}
        >
          {buttonTextSkip()}
        </TransitionButton>
      )}
    </div>
  )
}

export default SubmitButton
